shadow$provide[34] = function(global,require,module,exports) {

};